import React from "react";
import clsx from "clsx";

import {INFO_COLOR} from "../../../themes/themeConfigurator";
import WarningTooltip from "../../WarningTooltip";

const SkipIcon = props => {
  return (
    <WarningTooltip
      title={'Bitte überprüfen Sie die Angaben und bestätigen Sie mit “Speichern & weiter“.'}
      icon={<i className={clsx('fal fa-exclamation-circle', props.className)} style={{color: INFO_COLOR}} />}
    />
  )
};

export default SkipIcon;
